import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemLocation = function IconSystemLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.652 22.515C8.463 23.445 9 24 9 24s.537-.555 1.348-1.485C12.858 19.637 18 13.162 18 8.4 18 3.756 13.976 0 9 0S0 3.756 0 8.4c0 4.762 5.141 11.237 7.652 14.115M9 21.017a54 54 0 0 0 2.88-3.626c1.084-1.501 2.137-3.148 2.91-4.761C15.58 10.988 16 9.542 16 8.4 16 4.988 13.003 2 9 2S2 4.988 2 8.4c0 1.142.421 2.588 1.21 4.23.774 1.613 1.826 3.26 2.91 4.76A54 54 0 0 0 9 21.018",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }));
};